import { Component, Input, OnInit, HostListener, Inject, PLATFORM_ID } from "@angular/core";
import { isPlatformBrowser } from "@angular/common";
import { CommonModule } from "@angular/common";
import { ProductDisplayDescComponent } from "../../../../_components/product-display-desc/product-display-desc.component";

@Component({
    selector: 'app-easter-product-display',
    imports: [CommonModule, ProductDisplayDescComponent],
    template: `
    <div class="tw-px-5 md:tw-px-10 tw-py-4 tw-shadow-3xl upper-side-shadow-top  product-gradient" >
      <h2 class="tw-font-extrabold tw-font-poppins tw-text-xl md:tw-text-2xl lg:tw-text-3xl tw-text-center tw-text-neutral-700">
        {{ title }}
      </h2>
    </div>
    <div class="tw-w-full down-arrow"></div>
    <div class="tw-px-5 md:tw-px-10 tw-py-10 upper-side-shadow-top tw-bg-v4-grey-2">
      <div class="tw-flex tw-flex-row tw-items-center tw-justify-center tw-gap-4">
    
        <button
          class="tw-text-white tw-bg-neutral-600 tw-text-2xl tw-rounded-full tw-font-bold"
          (click)="prev()"
          [disabled]="!canGoPrev"
          [ngClass]="{'tw-opacity-50 tw-cursor-not-allowed': !canGoPrev, 'tw-cursor-pointer': canGoPrev}"
          type="button"
          >
          <i class="fas fa-angle-left"></i>
        </button>
    
        <div class="tw-w-full tw-grid tw-grid-cols-1 md:tw-grid-cols-2 lg:tw-grid-cols-4 tw-gap-2 tw-bg-v4-grey-1 tw-p-2">
          @for (item of displayItems; track $index; let i = $index) {
            <div class="tw-w-full"
              >
              <app-product-display-desc [productSlug]="item" ></app-product-display-desc>
            </div>
          }
        </div>
    
        <button
          class="tw-text-white tw-bg-neutral-600 tw-text-2xl tw-rounded-full tw-font-bold"
          (click)="next()"
          [disabled]="!canGoNext"
          [ngClass]="{'tw-opacity-50 tw-cursor-not-allowed': !canGoNext, 'tw-cursor-pointer': canGoNext}"
          type="button"
          >
          <i class="fas fa-angle-right"></i>
        </button>
      </div>
    
    </div>
    `,
    styleUrls: ['./product-display.component.scss']
})
export class EasterProductDisplayComponent implements OnInit {
    @Input() title: string = 'SHOP OUR EASTER DEALS';
    @Input() productList: string[] = [];
    @Input() steps: string[] = [];
    products: any[] = [];
    displayItems: string[] = [];

    private currentIndex: number = 0;
    private itemsToShow: number = 1;
    private maxIndex: number = 0;
    private isBrowser: boolean = false;

    constructor(@Inject(PLATFORM_ID) private platformId: Object) {
      this.isBrowser = isPlatformBrowser(this.platformId);
    }

    ngOnInit() {
      this.updateItemsToShow();
      if (this.isBrowser) {
        this.updateItemsToShow();
      }
    }

    @HostListener('window:resize', ['$event'])
    onResize(event: any) {
      if (this.isBrowser) {
        this.updateItemsToShow();
      }
    }

    private updateItemsToShow(): void {
      if (!this.isBrowser) return;
      const width = window.innerWidth;
      let newItemsToShow: number;

      if (width >= 1024) {
        newItemsToShow = 4;
      } else if (width >= 768) {
        newItemsToShow = 2;
      } else {
        newItemsToShow = 1;
      }

      if (newItemsToShow !== this.itemsToShow) {
        this.itemsToShow = newItemsToShow;
        this.updateDisplayItems();
      } else {
        this.updateDisplayItems();
      }
    }

    private updateDisplayItems(): void {
      this.maxIndex = Math.max(0, this.productList.length - this.itemsToShow);
      if (this.currentIndex > this.maxIndex) {
        this.currentIndex = this.maxIndex;
      }
      this.displayItems = [...this.productList.slice(this.currentIndex, this.currentIndex + this.itemsToShow)];
    }

    next(): void {
      if (this.currentIndex < this.maxIndex) {
        this.displayItems.shift();
        this.displayItems.push(this.productList[this.currentIndex + this.itemsToShow]);
        this.currentIndex++;
      }
    }

    prev(): void {
      if (this.currentIndex > 0) {
        this.displayItems.unshift(this.productList[this.currentIndex - 1]);
        this.displayItems.pop();
        this.currentIndex--;
      }
    }

    get canGoNext(): boolean {
      return this.currentIndex < this.maxIndex;
    }

    get canGoPrev(): boolean {
      return this.currentIndex > 0;
    }
}
